export const endPoints = "https://iqr.ryscocorrosion.com/iqr_system_backend/api/";